import { render, staticRenderFns } from "./DiscoverMovies.vue?vue&type=template&id=24f51e24&scoped=true&"
import script from "./DiscoverMovies.vue?vue&type=script&lang=js&"
export * from "./DiscoverMovies.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverMovies.vue?vue&type=style&index=0&id=24f51e24&lang=scss&scoped=true&"
import style1 from "./DiscoverMovies.vue?vue&type=style&index=1&id=24f51e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51e24",
  null
  
)

export default component.exports